import React, { useEffect, useState } from 'react';
import { fetchRoles, createRole, updateRole } from '../../services/Administracion/rolesService';
import { Role } from "../../types/roles"
import RoleModal from './RolesModal';
import { useAuth } from '../../context/AuthContext';

const RolesComponent: React.FC = () => {
    const { user } = useAuth();
    const [roles, setRoles] = useState<Role[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const [selectedRole, setSelectedRole] = useState<Role>({ role_id: 0, role_name: '', description: '', is_active: true, created_by: '', date_created: '' });
    const [showRoleModal, setShowRoleModal] = useState<boolean>(false);

    
    useEffect(() => {
        fetchRoles()
            .then((data) => {
                setRoles(data);
            })
            .catch((error) => {
                console.error("Error fetching roles: ", error);
                setError(error.message || "Error fetching roles");
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    const handleAddEditRole = (role?: Role) => {
        //const userWhitoutDomain = ad_username.includes('@') ? ad_username.split('@')[0] : ad_username;
        const userWithoutDomain = user?.User.email && user?.User.email.includes('@') ? user?.User.email.split('@')[0] : '';
        console.log('usuario en HandleAddEditRole: ',userWithoutDomain);
        setSelectedRole(role || { role_id: 0, role_name: '', description: '', is_active: true, created_by: userWithoutDomain || '', date_created: '' });
        setShowRoleModal(true);
    }

    const handleSaveRole = async (role: Role) => {
        const userWithoutDomain = user?.User.email && user?.User.email.includes('@') ? user?.User.email.split('@')[0] : '';
        role.updated_by = userWithoutDomain;
        role.created_by = userWithoutDomain;
        try {
            if (role.role_id) {
                //aunque en el service se llama a update en realidad se hace un post
                console.log('Role antes de update: ', role);
                await updateRole(role);
            } else {
                console.log('Role antes de create: ', role);
                await createRole(role);
            }
            const updatedRoles = await fetchRoles();
            setRoles(updatedRoles);
        } catch (err: any) {
            setError(err.message || "Error saving role");
        } finally {
            setShowRoleModal(false);
        }
    }

    if (loading) return <div className='container mt-4'>Cargando roles...</div>;
    if (error) return <div className='container mt-4 text-danger'>Error en el componente: {error}</div>;

    return (
        <div className='container mt-4'>
            <h1 className='mb-4'>Mantenimiento de Roles</h1>
            {/* <h6>{user?.User.email}</h6> */}
            <div className='mb-3 text-end'>
                <button className='btn btn-primary' onClick={() => handleAddEditRole()}>Crear Rol</button>
            </div>
            <table className='table table-stripped table-hover'>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Role</th>
                        <th>Descripción</th>
                        <th>Activo</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {roles.map((role: Role) => (
                        <tr key={role.role_id}>
                            <td>{role.role_id}</td>
                            <td>{role.role_name}</td>
                            <td>{role.description}</td>
                            <td>{role.is_active ? 'Si' : 'No'}</td>
                            <td>
                                <button className='btn btn-sm btn-secondary me-2' onClick={() => handleAddEditRole(role)}>Editar</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {showRoleModal && selectedRole && (
                <RoleModal
                    role={selectedRole}
                    onClose={() => setShowRoleModal(false)}
                    onSave={handleSaveRole}
                />
            )}
        </div>
    )

}

export default RolesComponent;